export function darkenHexColor(hex: string, percent: number): string {
    // Remove o #
    hex = hex.replace(/^#/, '')

    // Divide a string em r, g, b
    let r = parseInt(hex.substring(0, 2), 16)
    let g = parseInt(hex.substring(2, 4), 16)
    let b = parseInt(hex.substring(4, 6), 16)

    // Aplica a redução (darken)
    r = Math.max(0, Math.min(255, Math.floor(r * (1 - percent))))
    g = Math.max(0, Math.min(255, Math.floor(g * (1 - percent))))
    b = Math.max(0, Math.min(255, Math.floor(b * (1 - percent))))

    // Converte de volta pra hex
    const toHex = (n: number) => n.toString(16).padStart(2, '0')

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}
